import React, { useState } from "react";
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from "react-native";
import Feather from '@expo/vector-icons/Feather';
import { tenantActions } from "../../../redux/tenant.actions";
import { useDispatch } from "react-redux";
import { showErrorToast, showSuccesToast } from "../../helpers";
import InfowaningBox from "./infowaningBox";
import DropDownPicker from "../../../../../components/picker/DropDownPicker.web";
import STRINGS from "../../../redux/strings";
import { Modal } from "@material-ui/core";
import getPlatformType from "../../../../../helpers/helpers";

const TenantCard = ({ fieldsValue, onAddTenant }) => (
  <View style={styles.card}>
    <View style={styles.circle}>
      <Text style={styles.initials}>{fieldsValue?.first_name?.[0] || ''}</Text>
    </View>
    <View style={styles.cardContent}>
      <View style={styles.cardHeader}>
        <View style={styles.nameContainer}>
          <Text style={styles.name}>
            {`${fieldsValue?.first_name || ''} ${fieldsValue?.last_name || ''}`}
          </Text>
        </View>
        <View style={styles.buttonContainer}>
          <TouchableOpacity onPress={onAddTenant} style={styles.leadBadge}>
            <Text style={styles.leadText}>Add Tenant</Text>
          </TouchableOpacity>
        </View>
      </View>
      <Text style={styles.info}>TLYFE ID: {fieldsValue?.opbrix_id || ''}</Text>
      <Text style={styles.info}>Email: {fieldsValue?.email || ''}</Text>
      <Text style={styles.info}>Postcode: {fieldsValue?.post_code || ''}</Text>
      <Text style={styles.info}>Contact: {fieldsValue?.number || ''}</Text>
    </View>
  </View>
);

const TenantModal = (props) => {
  const { onClose, showModal, addedUsers, flowId } = props;
  const dispatch = useDispatch();

  const [fieldsValue, setFieldValues] = useState({
    tLyfeId: '',
  });

  const [formData, setFormData] = useState({
    emailOrTlyfeNumber: "",
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    contactNumber: "",
    postcode: "",
    address: "",
    title: ""
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.title || !formData.title.trim() || formData.title === 'Select here' || formData.title === '0') {
      newErrors.title = "Title is required";
    }
    if (!formData.firstName) newErrors.firstName = "First name is required";
    if (!formData.lastName) newErrors.lastName = "Last name is required";
    
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email";
    }
    
    if (formData.confirmEmail !== formData.email) {
      newErrors.confirmEmail = "Emails must match";
    }
    
    if (!formData.contactNumber) {
      newErrors.contactNumber = "Contact number is required";
    } else if (formData.contactNumber.length <= 7) {
      newErrors.contactNumber = "Contact number must be more than 7 digits";
    }
    if (!formData.postcode) newErrors.postcode = "Postcode is required";
    if (!formData.address) newErrors.address = "Address is required";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateSearch = () => {
    const newErrors = {};
    if (!formData.emailOrTlyfeNumber) {
      newErrors.emailOrTlyfeNumber = "Required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

      const tempData = {
        address: formData.address,
        confirm_email: formData.confirmEmail,
        contact_number: formData.contactNumber,
        email: formData.email,
        first_name: formData.firstName,
        isLeadTeanant: false,
        last_name: formData.lastName,
        postcode: formData.postcode,
        title: formData.title,
      };

      const finalArr = [
        ...addedUsers,
        {
          app_user: { user: { ...tempData } },
          is_lead: addedUsers?.length ? false : true
        }
      ];

      dispatch(tenantActions.saveTeanantDetails(
        { tenants: finalArr, flow_id: flowId },
        (data) => {
          setFieldValues({});
          setFormData({
            emailOrTlyfeNumber: "",
            firstName: "",
            lastName: "",
            email: "",
            confirmEmail: "",
            contactNumber: "",
            postcode: "",
            address: "",
            title: ""
          });
          onClose();
          showSuccesToast("Tenant added successfully!");
          fetchFlows();
        }
      ));
  };

  const handleSearchSubmit = () => {
    if (!validateSearch()) return;

    dispatch(tenantActions.getTenantByTlyfeId(
      formData?.emailOrTlyfeNumber.trim(),
      (response) => {
        if (response.status) {
          const data = response?.data?.user;
          setFieldValues({
            ...fieldsValue,
            title: data?.title,
            first_name: data?.first_name,
            last_name: data?.last_name,
            email: data?.email,
            confirm_email: data?.email,
            contact_number: data?.contact_number,
            isLeadTeanant: null,
            postcode: data?.postcode,
            address: data?.address,
            opbrix_id: response?.data?.opbrix_id
          });
        }
      }
    ));
  };

  const fetchFlows = () => {
    dispatch(tenantActions.getFlowInfo(flowId));
  };

  const handleAddExistingTenant = () => {
    const finalArr = [
      ...addedUsers,
      {
        app_user: { user: { ...fieldsValue } },
        is_lead: addedUsers?.length ? false : true
      }
    ];

    dispatch(tenantActions.saveTeanantDetails(
      { tenants: finalArr, flow_id: flowId },
      (data) => {
        setFieldValues({});
        setFormData({
          emailOrTlyfeNumber: "",
          firstName: "",
          lastName: "",
          email: "",
          confirmEmail: "",
          contactNumber: "",
          postcode: "",
          address: "",
          title: ""
        });
        onClose();
        showSuccesToast("Tenant added successfully!");
        fetchFlows();
      }
    ));
  };

  return (
    <Modal
    open={showModal ? showModal : false}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: 10,
      paddingRight: 10,
    }}
  >  
      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>
          <View style={styles.columnsContainer}>
            {/* Left Column - Search Existing Tenant */}
            <View style={styles.column}>
              <Text style={styles.header}>Check If Tenant is already on Tlyfe</Text>
              <InfowaningBox
                text={"Tlyfe pre-populates the tenant's verified ID and details for you."}
              />
              
              <TextInput 
                style={styles.input} 
                placeholder="Email or Tlyfe Number" 
                value={formData.emailOrTlyfeNumber}
                onChangeText={(text) => setFormData({ ...formData, emailOrTlyfeNumber: text })}
              />
              {errors.emailOrTlyfeNumber && (
                <Text style={styles.error}>{errors.emailOrTlyfeNumber}</Text>
              )}
              
              <View style={styles.buttonRow}>
                <TouchableOpacity style={styles.cancelButton} onPress={onClose}>
                  <Text style={styles.buttonText}>Cancel</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.searchButton} onPress={handleSearchSubmit}>
                  <Text style={styles.buttonText}>Search</Text>
                </TouchableOpacity>
              </View>
              
              {fieldsValue.opbrix_id && (
                <TenantCard 
                  fieldsValue={fieldsValue}
                  onAddTenant={handleAddExistingTenant}
                />
              )}
            </View>
            
            {/* Divider */}
            <View style={styles.dividerContainer}>
              <Text style={styles.dividerText}>OR</Text>
            </View>
            
            {/* Right Column - Add New Tenant */}
            <View style={styles.column}>
              <Text style={styles.header}>Add New Tenant</Text>
              <InfowaningBox
                text={"If you don't have all the tenant details to hand, just complete the first name, email and then ask the tenant to complete the remaining details in their Tlyfe app."}
              />
              
              <View style={styles.dropdownContainer}>
                <DropDownPicker
                  items={STRINGS.OPENFLOW_TITLES.map(ITEM => ({value: ITEM, label: ITEM}))}
                  title={'Title *'}
                  error={Boolean(errors.title)}
                  defaultValue={formData.title}
                  onChangeItem={(e) => {
                    setFormData({ ...formData, title: e.value });
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: undefined }));
                    }
                  }}
                />
              </View>
              {errors.title && <Text style={styles.error}>{errors.title}</Text>}
              
              <TextInput 
                style={styles.input} 
                placeholder="First Name" 
                value={formData.firstName}
                onChangeText={(text) => setFormData({ ...formData, firstName: text })}
              />
              {errors.firstName && <Text style={styles.error}>{errors.firstName}</Text>}
              
              <TextInput 
                style={styles.input} 
                placeholder="Last Name" 
                value={formData.lastName}
                onChangeText={(text) => setFormData({ ...formData, lastName: text })}
              />
              {errors.lastName && <Text style={styles.error}>{errors.lastName}</Text>}
              
              <TextInput 
                style={styles.input} 
                placeholder="Email" 
                keyboardType="email-address"
                value={formData.email}
                onChangeText={(text) => setFormData({ ...formData, email: text })}
              />
              {errors.email && <Text style={styles.error}>{errors.email}</Text>}
              
              <TextInput 
                style={styles.input} 
                placeholder="Confirm Email" 
                keyboardType="email-address"
                value={formData.confirmEmail}
                onChangeText={(text) => setFormData({ ...formData, confirmEmail: text })}
              />
              {errors.confirmEmail && <Text style={styles.error}>{errors.confirmEmail}</Text>}
              
              <TextInput 
                style={styles.input} 
                placeholder="Contact Number" 
                keyboardType="phone-pad"
                value={formData.contactNumber}
                onChangeText={(text) => setFormData({ ...formData, contactNumber: text.replace(/[^0-9]/g, '') })}
              />
              {errors.contactNumber && <Text style={styles.error}>{errors.contactNumber}</Text>}
              
              <TextInput 
                style={styles.input} 
                placeholder="Postcode" 
                value={formData.postcode}
                onChangeText={(text) => setFormData({ ...formData, postcode: text })}
              />
              {errors.postcode && <Text style={styles.error}>{errors.postcode}</Text>}
              
              <TextInput 
                style={styles.input} 
                placeholder="Address" 
                value={formData.address}
                onChangeText={(text) => setFormData({ ...formData, address: text })}
              />
              {errors.address && <Text style={styles.error}>{errors.address}</Text>}
              
              <View style={styles.buttonRow}>
                <TouchableOpacity style={styles.cancelButton} onPress={onClose}>
                  <Text style={styles.buttonText}>Cancel</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.submitButton} onPress={handleSubmit}>
                  <Text style={styles.buttonText}>Add Tenant</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};
const layoutType = getPlatformType()
const styles = StyleSheet.create({
  modal: {
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 10,
    width: '90%',
    maxHeight: '90%',
    overflow:"scroll"
  },
  modalContent: {
    padding: 20,
  },
  columnsContainer: {
    flexDirection: layoutType=="web"? 'row':"column",


  },
  column: {
    flex: 1,
    padding: 10,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 3,
  },
  dividerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: layoutType=="web"? 0:20,
  },
  dividerText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  header: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 10,
    borderRadius: 5,
    marginBottom: 10,
  },
  error: {
    color: 'red',
    fontSize: 12,
    marginBottom: 5,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  cancelButton: {
    backgroundColor: '#ccc',
    padding: 10,
    borderRadius: 5,
    flex: 1,
    marginRight: 5,
    alignItems: 'center',
  },
  searchButton: {
    backgroundColor: '#d63384',
    padding: 10,
    borderRadius: 5,
    flex: 1,
    marginLeft: 5,
    alignItems: 'center',
  },
  submitButton: {
    backgroundColor: '#6a4bb3',
    padding: 10,
    borderRadius: 5,
    flex: 1,
    marginLeft: 5,
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontWeight: 'bold',
  },
  dropdownContainer: {
    width: '100%',
    marginBottom: 10,
  },
  card: {
    backgroundColor: 'white',
    padding: 16,
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 3,
    maxWidth: 340,
    marginTop: 10,
  },
  circle: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#d3c4f4',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  initials: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'black',
  },
  cardContent: {
    flex: 1,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  nameContainer: {
    flex: 0.6,
  },
  name: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  info: {
    fontSize: 12,
    color: '#555',
  },
  leadBadge: {
    backgroundColor: '#6a4bb3',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 5,
  },
  leadText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
});

export default TenantModal;